import type { AcoesDaRegra, CondicaoDaRegra, CondicoesDaRegra } from '@waymail/core';
import type { RegraEditavel } from './consultas';

/**
 * O lado da tela das regras (ADR 0042): descrever em portugues o que a regra
 * faz e montar a regra do "Bloquear remetente". Puro, para testar sem React.
 */

const CAMPOS: Record<CondicaoDaRegra['field'], string> = {
  from: 'o remetente',
  to: 'o destinatário',
  subject: 'o assunto',
  hasAttachment: 'tem anexo',
};

export const ROTULO_DO_CAMPO: Record<CondicaoDaRegra['field'], string> = {
  from: 'Remetente',
  to: 'Destinatário',
  subject: 'Assunto',
  hasAttachment: 'Tem anexo',
};

function condicao(c: CondicaoDaRegra): string {
  if (c.field === 'hasAttachment') return CAMPOS.hasAttachment;
  return `${CAMPOS[c.field]} ${c.op === 'equals' ? 'é' : 'contém'} "${c.value}"`;
}

export function descreverCondicoes(c: CondicoesDaRegra): string {
  const partes = c.items.map(condicao);
  return `Quando ${partes.join(c.match === 'all' ? ' e ' : ' ou ')}`;
}

/** `nomeDaPasta` resolve o id de destino; pasta que sumiu aparece como tal. */
export function descreverAcoes(
  a: AcoesDaRegra,
  nomeDaPasta: (id: string) => string | null,
): string {
  const partes: string[] = [];
  if (a.markRead === true) partes.push('marcar como lida');
  if (a.flag === true) partes.push('sinalizar');
  if (a.delete === true) partes.push('mover para a lixeira');
  else if (a.moveTo != null)
    partes.push(`mover para ${nomeDaPasta(a.moveTo) ?? 'uma pasta que não existe mais'}`);
  return partes.length === 0 ? 'nada' : partes.join(', ');
}

/**
 * "Bloquear remetente" e uma regra como outra qualquer: remetente igual ao
 * endereco, para a lixeira, e para por ali. Endereco igual, nao contem -
 * bloquear `ana@x.com` nao pode levar junto `mariana@x.com`.
 */
export function regraDeBloqueio(accountId: string, endereco: string): RegraEditavel {
  return {
    accountId,
    name: `Bloquear ${endereco}`,
    enabled: true,
    conditions: { match: 'all', items: [{ field: 'from', op: 'equals', value: endereco }] },
    actions: { delete: true },
    stopProcessing: true,
  };
}
